import React from 'react'
import PropTypes from 'prop-types'
import trophy from 'media/trophy.svg'
import { FormattedMessage } from 'react-intl'
import FormattedWeight from '../../components/FormattedWeight'
import useBreakpoints from '../../hooks/useBreakpoints'
import PremiumButton from '../../components/PremiumButton/PremiumButton'

export default function QuoteSection({ supplementaryCtaText }) {
  const { LG } = useBreakpoints()
  return (
    <div className="o-width-limiter o-width-limiter--narrow text-center">
      <div className="flex flex-col overflow-hidden rounded-8 border-1 border-Border shadow-elevated lg:flex-row lg:rounded-16">
        <img
          src={require('./nathalie.jpg')}
          alt=""
          className="shrink-0 object-cover lg:w-1/2"
        />
        <div className="my-auto p-24 md:p-32 lg:p-40 xl:p-56">
          <h3 className="text-BrandDark type-14-bold-caps lg:type-20-bold-caps">
            –<FormattedWeight weightInKg={5} />{' '}
            <FormattedMessage
              id="Kickstarter.weeks"
              defaultMessage="in 3 weeks"
            />
          </h3>
          <blockquote>
            <p className="demibolden-children mb-12 mt-8 leading-body md:mb-16 md:mt-12 lg:mb-24 lg:type-24 xl:mt-16 xxl:type-28">
              <FormattedMessage
                id="homepage_user_quote_short"
                defaultMessage="This app is like the best thing that has happened to my health. I was shocked how my <b>cravings were gone</b> after only a couple of days and not wanting to eat between meals really helped. Losing 5kg in only 3 weeks is fantastic, but the best part is the health improvement."
                values={{
                  b: function Bold(...chunks) {
                    return <b>{chunks}</b>
                  },
                }}
              />
            </p>
            <footer>
              <cite className="demibolden-children type-14 lg:type-20">
                <b>Nathalie, 27</b>
                <br />
                <FormattedMessage
                  id="Kickstarter.quoteTitle"
                  defaultMessage="3 week weight loss meal plan"
                />
              </cite>
            </footer>
          </blockquote>
        </div>
      </div>
      <div className="-mb-16 mt-36 justify-center lg:mt-72 lg:flex">
        <img
          src={trophy}
          alt=""
          className="mb-12 lg:mb-0 lg:mr-20"
          style={{ width: LG ? 40 : 30 }}
        />
        <p className="my-auto">{supplementaryCtaText}</p>
      </div>
      <PremiumButton GALabel={'Features middle of page'} />
    </div>
  )
}

QuoteSection.propTypes = {
  supplementaryCtaText: PropTypes.string.isRequired,
}
